import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-save-button',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './save-button.component.html',
  styleUrl: './save-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SaveButtonComponent {
  readonly buttonDisabled = input<boolean>(false);

  @Output() readonly onSaveClicked = new EventEmitter<void>();

  onSubmit(): void {
    this.onSaveClicked.emit();
  }
}
